var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CDropdownHeader',[_c('CButton',{attrs:{"id":"sair"},on:{"click":_vm.logout}},[_c('CIcon',{attrs:{"name":"cilAccountLogout"}}),_vm._v(" Sair ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }